import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../images/SKIP.svg';
import './legal.css';

type LegalPageLayoutProps = {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
};

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, lastUpdated, children }) => (
  <div className="legal-page">
    <div className="legal-page__inner">
      <Link to="/" className="legal-page__back">
        ← Back to sign in
      </Link>
      <img src={Logo} alt="SkipScreen" className="legal-page__logo" />
      <h1>{title}</h1>
      <p className="legal-page__updated">Last updated: {lastUpdated}</p>
      {children}
    </div>
  </div>
);

export default LegalPageLayout;
